import axios from "axios";
import jQuery from "jquery";
import Vue from "vue";

import settingHelp from "@/config/localSetting";
const config = settingHelp.getConfig();
const { baseURL, remoteURL } = config;

export function downloadFile(requestUrl, queryParams) {
  let iframe = document.getElementById("_downloadHiddenFrame");
  if (!iframe) {
    var downloadDiv = document.createElement("div");
    downloadDiv.style.display = "none";
    document.body.appendChild(downloadDiv);
    downloadDiv.innerHTML =
      "<iframe id='_downloadHiddenFrame' name='_downloadHiddenFrame' style='display:none;'></iframe>";
  }
  window.open(
    remoteURL +
      requestUrl +
      (queryParams ? "?" + jQuery.param(queryParams) : ""),
    "_downloadHiddenFrame"
  );
}

/**
 * 导出文件方法
 * @param {String} method [请求方式]
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param {String} fileName [导出的文件名，例：test.xlsx]
 */
export function commDownFile(method = "post", url, params, fileName) {
  return new Promise((resolve, reject) => {
    // axios.defaults.headers["content-type"] = "application/json;charset=UTF-8";
    axios({
      baseURL,
      method: method,
      url: url,
      params: params,
      responseType: "blob",
    }).then((res) => {
      let reader = new FileReader();
      let data = res.data;
      if (res.status == 200) {
        reader.onload = (e) => {
          if (
            e.target.result.indexOf("Result") != -1 &&
            JSON.parse(e.target.result).Result == false
          ) {
            // 进行错误处理
          } else {
            if (!fileName) {
              let contentDisposition = res.headers["content-disposition"];
              if (contentDisposition) {
                fileName = window.decodeURI(
                  res.headers["content-disposition"]
                    .split("=")[2]
                    .split("''")[1],
                  "UTF-8"
                );
              }
            }
            executeDownload(data, fileName);
          }
        };
        reader.readAsText(data);
        resolve(res.data);
      } else {
        Vue.$message({ message: "下载失败", showClose: true, type: "error" });
      }
    });
  });
}

//  模拟点击a 标签进行下载
function executeDownload(data, fileName) {
  if (!data) {
    return;
  }
  let url = getObjectURLFromBlob(data);
  let link = document.createElement("a");
  link.style.display = "none";
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function commDownFileAndReturnUrl(
  method = "post",
  url,
  params,
  fileName
) {
  return new Promise((resolve, reject) => {
    axios({
      baseURL,
      method: method,
      url: url,
      params: params,
      responseType: "blob",
    }).then((res) => {
      let reader = new FileReader();
      let data = res.data;
      reader.onload = (e) => {
        if (
          e.target.result.indexOf("Result") != -1 &&
          JSON.parse(e.target.result).Result == false
        ) {
          // 进行错误处理
        } else {
          if (!fileName) {
            let contentDisposition = res.headers["content-disposition"];
            if (contentDisposition) {
              fileName = window.decodeURI(
                res.headers["content-disposition"].split("=")[2].split("''")[1],
                "UTF-8"
              );
            }
          }
        }
      };
      reader.readAsText(data);
      resolve(res.data);
    });
  }).then((value) => {
    return getObjectURLFromBlob(value);
  });
}

export function commDownFileWithFun(
  method = "post",
  url,
  params,
  fileName,
  fun
) {
  return new Promise((resolve, reject) => {
    axios({
      baseURL,
      method: method,
      url: url,
      params: params,
      responseType: "blob",
    }).then((res) => {
      let reader = new FileReader();
      let data = res.data;
      reader.readAsText(data);
      resolve(data);
      if (typeof fun == "function") {
        fun(data);
      }
    });
  });
}

function getObjectURLFromFile(file) {
  let url = null;
  if (window.createObjectURL != undefined) {
    // basic
    url = window.createObjectURL(file);
  } else if (window.webkitURL != undefined) {
    // webkit or chrome
    try {
      url = window.webkitURL.createObjectURL(file);
    } catch (error) {}
  } else if (window.URL != undefined) {
    // mozilla(firefox)
    try {
      url = window.URL.createObjectURL(file);
    } catch (error) {}
  }
  return url;
}

function getObjectURLFromBlob(data) {
  let url = null;
  if (window.createObjectURL != undefined) {
    // basic
    url = window.createObjectURL(new Blob([data]));
  } else if (window.webkitURL != undefined) {
    // webkit or chrome
    try {
      url = window.webkitURL.createObjectURL(new Blob([data]));
    } catch (error) {}
  } else if (window.URL != undefined) {
    // mozilla(firefox)
    try {
      url = window.URL.createObjectURL(new Blob([data]));
    } catch (error) {}
  }
  return url;
}
